'use strict';

const formatEndWithDaysAfter = ({ end, daysAfter, locale }) => {
  switch (locale) {
    case "en": {
      switch (true) {
        /** 음수 기간은 말이 안 되지만, 일단 처리해줌. 이상값 핸들링은 사용처에서 알아서 할 것. */
        case daysAfter < 0: {
          return `${daysAfter} days before ${end}`;
        }
        case daysAfter === 0: {
          return end;
        }
        case daysAfter === 1: {
          return `Next day ${end}`;
        }
        case daysAfter > 0: {
          return `${daysAfter} days later ${end}`;
        }
        default: {
          throw new Error("[formatEndWithDaysAfter] case\uC5D0\uC11C \uB2E4 \uCC98\uB9AC\uB428");
        }
      }
    }
    case "ko": {
      switch (true) {
        /** 음수 기간은 말이 안 되지만, 일단 처리해줌. 이상값 핸들링은 사용처에서 알아서 할 것. */
        case daysAfter < 0: {
          return `${daysAfter}\uC77C \uC804 ${end}`;
        }
        case daysAfter === 0: {
          return end;
        }
        case daysAfter === 1: {
          return `\uB2E4\uC74C \uB0A0 ${end}`;
        }
        case daysAfter > 0: {
          return `${daysAfter}\uC77C \uD6C4 ${end}`;
        }
        default: {
          throw new Error("[formatEndWithDaysAfter] case\uC5D0\uC11C \uB2E4 \uCC98\uB9AC\uB428");
        }
      }
    }
  }
};

exports.formatEndWithDaysAfter = formatEndWithDaysAfter;
//# sourceMappingURL=formatEndWithDaysAfter.cjs.map
